/*
does allow following patterns
https://example.com
http://test.de
example.org/info
www.example.de (optional mit http(s):
*/
export const urlRegex = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/\S*)?$/i;

export const htmlTagRegex = /^(?:<([a-zA-Z][a-zA-Z0-9]*)(?:\s+[^>]*)?(?:>.*?<\/\1>|\/>)|[^<>]+)*$/s;

export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
